import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { PriceHistoryResponseModel } from '@/types/clarityLens'

export const getPriceHistory = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string,
  metric?: string
): Promise<PriceHistoryResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/spend-lens/item/price-history`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          dcn: branchName,
          item_name: itemName,
          ...(metric ? { metric } : {}),
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
